import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCodeCircle01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm-1.793 8.707a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L7.914 12l2.293-2.293Zm5-1.414a1 1 0 1 0-1.414 1.414L16.086 12l-2.293 2.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgCodeCircle01.displayName = 'CodeCircle01';
export default SvgCodeCircle01;
